export default __webpack_public_path__ + "43bec3e66b99189b02ee65bb6f68a45c.svg";